import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { FundoProjetor, COLORS } from "@/components/DesafioFundo";
import useBarlow from "@/components/useBarlow";

const AV_URL = (a) => `/desafio/avatares/${a}.png`;
const LOGO = "/desafio/logo-mpires-branco.png";
const CONECTA = "/mascote/conecta-3d.png";
const CORS = ["#117DBB","#D98B20","#B23A3A","#2E8B4D"];
const CORS_DIM = ["#05517D","#41554E","#353D56","#0E555C"];
const SHAPES = ["●","▲","■","◆"];
const BASE = process.env.REACT_APP_BACKEND_URL;

const CSS = `
html,body,#root{height:100%;overflow:hidden}
@keyframes voo{0%,100%{transform:perspective(700px) translate(0,0) rotateY(0) rotateZ(0)}25%{transform:perspective(700px) translate(7px,-6px) rotateY(14deg) rotateZ(2deg)}50%{transform:perspective(700px) translate(0,-10px)}75%{transform:perspective(700px) translate(-7px,-5px) rotateY(-14deg) rotateZ(-2deg)}}
@keyframes hop{0%,100%{transform:translateY(0)}40%{transform:translateY(-45%) rotate(-10deg)}60%{transform:translateY(-45%) rotate(10deg)}}
@keyframes popin{0%{transform:scale(0);opacity:0}100%{transform:scale(1);opacity:1}}
@keyframes confetti{0%{transform:translateY(-100vh) rotate(0)}100%{transform:translateY(100vh) rotate(720deg)}}
.conecta{animation:voo 5.2s ease-in-out infinite}
.conecta.pod{animation-duration:3.8s}
.hop{animation:hop .6s ease-in-out infinite}
.popin{animation:popin .4s ease-out}
.confetti{position:absolute;width:10px;height:14px;animation:confetti 3.5s linear infinite}
`;

function AvatarBolha({ avatar, size = "4vw" }) {
  return (
    <div style={{ width: size, height: size, borderRadius: "50%", background: "rgba(255,255,255,0.08)", display: "inline-flex", alignItems: "center", justifyContent: "center", overflow: "hidden", border: "2px solid rgba(255,255,255,0.3)" }}>
      <img src={AV_URL(avatar)} alt="" style={{ width: "90%", height: "90%", objectFit: "contain" }} />
    </div>
  );
}

export default function DesafioProjetor() {
  useBarlow();
  const { pin } = useParams();
  const [state, setState] = useState(null);
  const [prevPos, setPrevPos] = useState({}); // posições na rodada anterior (para ▲▼)
  const [currentPos, setCurrentPos] = useState({});
  const timerRef = useRef(null);
  const lastQuestionIdxRef = useRef(-1);

  const tick = async () => {
    try {
      const { data } = await api.get(`/desafio/salas/${pin}/host`);
      setState(data);
      if (data.ranking) {
        const map = {}; data.ranking.forEach((r) => { map[r.token] = r.pos; });
        // Quando mudar a pergunta, snapshot do que era "atual" vira "anterior".
        if (data.status === "rank" && lastQuestionIdxRef.current !== data.pergunta_atual) {
          setPrevPos(currentPos);
          lastQuestionIdxRef.current = data.pergunta_atual;
        }
        setCurrentPos(map);
      }
    } catch {}
  };
  useEffect(() => {
    let stop = false;
    const loop = async () => {
      while (!stop) {
        if (!document.hidden) { await tick(); }
        await new Promise((r) => { timerRef.current = setTimeout(r, document.hidden ? 2000 : 1000); });
      }
    };
    const onVis = () => { if (!document.hidden) { clearTimeout(timerRef.current); } };
    document.addEventListener("visibilitychange", onVis);
    loop();
    return () => { stop = true; clearTimeout(timerRef.current); document.removeEventListener("visibilitychange", onVis); };
    /* eslint-disable-next-line */
  }, [pin]);

  const iniciar = async () => { try { await api.post(`/desafio/salas/${pin}/iniciar`); tick(); } catch {} };

  if (!state) return <div style={{ background: COLORS.navy, color: "#fff", width: "100vw", height: "100vh", display: "grid", placeItems: "center" }}>Carregando…</div>;

  const S = state.status;
  const rest = Math.ceil((state.fase_resta_ms || 0) / 1000);
  const perg = state.pergunta;
  const qrUrl = `${BASE}/api/desafio/qr.png?pin=${pin}&url=${encodeURIComponent(`${window.location.origin}/desafio/${pin}`)}&size=600`;

  const bg = { background: COLORS.navy, color: "#fff", width: "100vw", height: "100vh", padding: "clamp(16px,2vw,32px)", boxSizing: "border-box", fontFamily: "'Barlow',sans-serif", position: "relative", overflow: "hidden" };

  const header = (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", height: "6vh", marginBottom: "2vh", position: "relative", zIndex: 2 }}>
      <div style={{ display: "flex", alignItems: "center", gap: "1.4vw" }}>
        <img src={LOGO} alt="MPires" style={{ height: "4.6vh" }} />
        <span style={{ fontSize: "2.4vw", fontWeight: 800, letterSpacing: 1 }}>Desafio</span>
        {S === "question" && <span style={{ fontSize: "1.2vw", color: COLORS.textSec }}>Pergunta {state.pergunta_atual + 1} de {state.total_perguntas}</span>}
      </div>
      <div style={{ padding: "0.6vh 1.4vw", borderRadius: 999, border: "1.5px solid rgba(255,255,255,0.28)", fontSize: "1.1vw", fontWeight: 600, background: "rgba(255,255,255,0.08)" }}>{state.treinamento}</div>
    </div>
  );

  return (
    <div style={bg}>
      <style>{CSS}</style>
      <FundoProjetor />
      <div style={{ position: "relative", zIndex: 2 }}>
      {header}

      {S === "waiting" && (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "3vw", alignItems: "start", height: "88vh" }}>
          <div>
            <h1 style={{ fontSize: "clamp(32px,3.6vw,64px)", fontWeight: 800, margin: "0 0 1vh" }}>Prontos para o desafio?</h1>
            <p style={{ color: COLORS.textSec, fontSize: "1.4vw", margin: "0 0 2vh" }}>Aponte a câmera do celular para o QR Code e digite seu nome.</p>
            <div style={{ background: "#fff", padding: "1.2vw", borderRadius: 16, display: "inline-block" }}>
              <img src={qrUrl} alt="QR" style={{ width: "14vw", height: "14vw", display: "block" }} data-testid="projetor-qr" />
            </div>
            <div style={{ marginTop: "2vh", color: COLORS.textSec, fontSize: "1.2vw" }}>ou acesse e digite o PIN</div>
            <div style={{ fontSize: "clamp(36px,5vw,96px)", fontWeight: 800, letterSpacing: "0.6vw" }}>{pin.replace(/(\d{3})(\d{3})/, "$1 $2")}</div>
            <div data-testid="projetor-sem-camera" style={{ marginTop: "1.6vh", color: COLORS.textSec, fontSize: "1.3vw", fontWeight: 600 }}>
              Sem câmera? Acesse <span style={{ color: "#fff" }}>mpempresarial.com.br/desafio</span> e digite o PIN
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", height: "100%", gap: "1.4vh" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "1vw" }}>
              <div style={{ textAlign: "right" }}>
                <div style={{ fontSize: "1.8vw", fontWeight: 700 }}>{state.jogadores.length} participantes</div>
                <div style={{ fontSize: "1.1vw", color: COLORS.textSec }}>na sala</div>
              </div>
              <img src={CONECTA} alt="Conecta" className="conecta" style={{ width: "11vw" }} />
            </div>
            <button onClick={iniciar} data-testid="btn-iniciar"
              style={{ alignSelf: "flex-end", background: "#fff", color: COLORS.navy, border: 0, padding: "1.4vh 2.4vw", fontSize: "1.6vw", fontWeight: 800, borderRadius: 999, cursor: "pointer", boxShadow: "0 8px 24px rgba(0,20,35,0.25)" }}>
              Começar o desafio ▶
            </button>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "0.8vw", alignContent: "flex-start", justifyContent: "flex-end" }}>
              {state.jogadores.map((j) => (
                <div key={j.token} className="popin" style={{ display: "inline-flex", alignItems: "center", gap: "0.6vw", background: "rgba(255,255,255,0.08)", borderRadius: 999, padding: "0.4vh 1vw 0.4vh 0.4vh" }}>
                  <AvatarBolha avatar={j.avatar} size="2.4vw" />
                  <span style={{ fontWeight: 600, fontSize: "1.1vw" }}>{j.nome}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {S === "question" && perg && (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 23vw", gap: "2vw", height: "88vh" }}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", gap: "1.4vw" }}>
              <h1 style={{ fontSize: "clamp(24px,3.3vw,56px)", fontWeight: 800, margin: 0, maxWidth: "60vw", lineHeight: 1.15 }}>{perg.pergunta}</h1>
              <div style={{ width: "7vw", height: "7vw", borderRadius: "50%", border: `0.4vw solid ${COLORS.accent}`, display: "grid", placeItems: "center", fontSize: "3vw", fontWeight: 800, flexShrink: 0, background: "rgba(255,255,255,0.08)" }}>{rest}</div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "1.4vw", margin: "2vh 0" }}>
              <img src={CONECTA} alt="" className="conecta" style={{ width: "7vw" }} />
              <div style={{ fontSize: "1.4vw", fontWeight: 600 }}>{state.respondidos.length} de {state.jogadores.length}<div style={{ fontSize: "1vw", color: COLORS.textSec }}>já responderam</div></div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1vw", flex: 1 }}>
              {perg.alternativas.map((a, i) => (
                <div key={i} style={{ background: CORS[i], color: "#fff", padding: "0 1.4vw", borderRadius: "1vw", fontSize: "clamp(16px,1.9vw,32px)", fontWeight: 600, display: "flex", alignItems: "center", gap: "1vw", minHeight: "12vh" }}>
                  <span style={{ width: "2.6vw", height: "2.6vw", borderRadius: "50%", background: "rgba(255,255,255,0.25)", display: "inline-grid", placeItems: "center", flexShrink: 0 }}>{SHAPES[i]}</span>
                  {a}
                </div>
              ))}
            </div>
          </div>
          <RankingLateral state={state} />
        </div>
      )}

      {S === "answer" && perg && (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 23vw", gap: "2vw", height: "88vh" }}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ fontSize: "clamp(22px,2.6vw,44px)", fontWeight: 800, marginBottom: "1.4vh" }}>{perg.pergunta}</div>
            <div style={{ display: "flex", gap: "1.4vw", alignItems: "flex-start", marginBottom: "1.4vh" }}>
              <img src={CONECTA} className="conecta" alt="" style={{ width: "6vw" }} />
              <div style={{ background: "rgba(255,255,255,0.08)", padding: "1.2vh 1.2vw", borderRadius: 12, flex: 1, fontSize: "1.3vw" }}>{perg.explicacao}</div>
            </div>
            <div style={{ fontSize: "1.2vw", fontWeight: 600, marginBottom: "0.8vh" }}>Acertaram:</div>
            <div style={{ display: "flex", gap: "0.8vw", flexWrap: "wrap", marginBottom: "1.4vh", minHeight: "5vh" }}>
              {state.acertaram.map((tok) => {
                const j = state.jogadores.find((p) => p.token === tok);
                if (!j) return null;
                return <div key={tok} className="hop" style={{ display: "inline-block" }}><AvatarBolha avatar={j.avatar} size="3vw" /></div>;
              })}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1vw", flex: 1 }}>
              {perg.alternativas.map((a, i) => {
                const correta = perg.correta === i;
                return (
                  <div key={i} style={{ background: correta ? CORS[i] : CORS_DIM[i], color: correta ? "#fff" : "rgba(153,209,223,0.6)", padding: "0 1.4vw", borderRadius: "1vw", fontSize: "clamp(16px,1.9vw,32px)", fontWeight: 600, display: "flex", alignItems: "center", gap: "1vw", minHeight: "12vh", border: correta ? "4px solid #fff" : "4px solid transparent" }}>
                    <span style={{ width: "2.6vw", height: "2.6vw", borderRadius: "50%", background: correta ? "rgba(255,255,255,0.25)" : "rgba(153,209,223,0.15)", display: "inline-grid", placeItems: "center", flexShrink: 0 }}>{SHAPES[i]}</span>
                    {a}
                  </div>
                );
              })}
            </div>
          </div>
          <RankingLateral state={state} />
        </div>
      )}

      {S === "rank" && (
        <div style={{ height: "88vh" }}>
          <div style={{ fontSize: "1vw", letterSpacing: 2, color: COLORS.textSec, fontWeight: 700 }}>PERGUNTA {state.pergunta_atual + 1} DE {state.total_perguntas}</div>
          <h1 style={{ fontSize: "clamp(32px,3.4vw,56px)", fontWeight: 800, margin: "0.4vh 0 2vh" }}>Ranking</h1>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 18vw", gap: "2vw" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "1vh" }}>
              {state.ranking.slice(0, 5).map((r, i) => {
                const medal = ["#D4AF37","#C0C0C0","#CD7F32"][i];
                const max = Math.max(...state.ranking.map((x) => x.pontos), 1);
                const antes = prevPos[r.token];
                const delta = antes ? antes - r.pos : 0;
                return (
                  <div key={r.token} style={{ display: "flex", alignItems: "center", gap: "1vw", background: "rgba(255,255,255,0.08)", border: "1.5px solid rgba(255,255,255,0.18)", padding: "1.2vh 1.2vw", borderRadius: 14 }}>
                    <div style={{ width: "2.8vw", height: "2.8vw", borderRadius: "50%", background: medal || "rgba(255,255,255,0.15)", display: "grid", placeItems: "center", fontWeight: 800, color: medal ? COLORS.navy : "#fff", fontSize: "1.4vw" }}>{r.pos}</div>
                    <AvatarBolha avatar={r.avatar} size="3.6vw" />
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: "1.6vw", fontWeight: 700 }}>{r.nome}</div>
                      <div style={{ height: "0.9vh", borderRadius: 999, background: "rgba(255,255,255,0.1)", overflow: "hidden", marginTop: 4 }}>
                        <div style={{ width: `${(r.pontos/max)*100}%`, height: "100%", background: COLORS.cyan }} />
                      </div>
                    </div>
                    {delta !== 0 && (
                      <span style={{ color: delta > 0 ? "#2E8B4D" : "#B23A3A", fontSize: "1.4vw", fontWeight: 700 }}>{delta > 0 ? "▲" : "▼"}{Math.abs(delta)}</span>
                    )}
                    <div style={{ fontSize: "1.8vw", fontWeight: 800, minWidth: "5vw", textAlign: "right" }}>{r.pontos}</div>
                  </div>
                );
              })}
            </div>
            <div style={{ textAlign: "center" }}>
              <img src={CONECTA} className="conecta" alt="" style={{ width: "12vw" }} />
              <div style={{ marginTop: "1.2vh", padding: "0.8vh 1.2vw", borderRadius: 999, border: "1.5px solid rgba(255,255,255,0.28)", display: "inline-block", fontSize: "1vw", background: "rgba(255,255,255,0.08)" }}>Próxima pergunta</div>
              <div style={{ color: COLORS.textSec, fontSize: "0.9vw", marginTop: "0.8vh" }}>segue sozinho em {rest}s</div>
            </div>
          </div>
        </div>
      )}

      {S === "podium" && (
        <div style={{ textAlign: "center", position: "relative", height: "88vh" }}>
          {Array.from({ length: 40 }).map((_, i) => (
            <span key={i} className="confetti" style={{ left: `${(i * 7) % 100}%`, background: CORS[i % 4], animationDelay: `${(i % 10) * 0.15}s` }} />
          ))}
          <div style={{ fontSize: "1vw", letterSpacing: 2, fontWeight: 700, color: COLORS.textSec }}>DESAFIO CONCLUÍDO</div>
          <h1 style={{ fontSize: "clamp(36px,4vw,72px)", fontWeight: 800, margin: "0.4vh 0 3vh" }}>Pódio</h1>
          <div style={{ display: "flex", justifyContent: "center", alignItems: "end", gap: "2vw" }}>
            {[1, 0, 2].map((idx) => {
              const r = state.ranking[idx]; if (!r) return <div key={idx} />;
              const h = ["28vh", "22vh", "15vh"][[0, 1, 2].indexOf(idx)];
              const cor = ["#D4AF37","#C0C0C0","#CD7F32"][idx];
              return (
                <div key={idx} style={{ textAlign: "center" }}>
                  {idx === 0 && <div style={{ fontSize: "3vw", marginBottom: 4 }}>👑</div>}
                  <AvatarBolha avatar={r.avatar} size="8vw" />
                  <div style={{ fontSize: "1.8vw", fontWeight: 800, marginTop: "1vh" }}>{r.nome}</div>
                  <div style={{ fontSize: "1.1vw", color: COLORS.textSec }}>{r.pontos} pts</div>
                  <div style={{ width: "10vw", height: h, background: cor, color: COLORS.navy, borderRadius: "12px 12px 4px 4px", marginTop: "1vh", display: "grid", placeItems: "center", fontSize: "3.6vw", fontWeight: 900 }}>{idx + 1}</div>
                </div>
              );
            })}
          </div>
          <img src={CONECTA} alt="" className="conecta pod" style={{ width: "9vw", position: "absolute", bottom: "2vh", left: "4vw" }} />
        </div>
      )}
      </div>
    </div>
  );
}

function RankingLateral({ state }) {
  return (
    <div style={{ background: "rgba(255,255,255,0.08)", borderRadius: 16, padding: "1.4vh 1vw", border: "1.5px solid rgba(255,255,255,0.18)" }}>
      <div style={{ fontSize: "0.9vw", letterSpacing: 2, color: COLORS.textSec, fontWeight: 700, marginBottom: "1vh" }}>RANKING</div>
      {state.ranking.slice(0, 5).map((r) => (
        <div key={r.token} style={{ display: "flex", alignItems: "center", gap: "0.6vw", padding: "0.6vh 0", borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
          <AvatarBolha avatar={r.avatar} size="2vw" />
          <span style={{ flex: 1, fontSize: "1.1vw", fontWeight: 600 }}>{r.nome}</span>
          {state.respondidos.includes(r.token) && <span style={{ color: "#2E8B4D", fontSize: "1.2vw" }}>✓</span>}
          <span style={{ fontWeight: 700, fontSize: "1.1vw", minWidth: "3vw", textAlign: "right" }}>{r.pontos}</span>
        </div>
      ))}
    </div>
  );
}
